(function() { window.GUID_6ab35827_2627_4e09_b781_3ecce8262d6d = { getGuid: function() { return "6ab35827-2627-4e09-b781-3ecce8262d6d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var Graph;
        (function (Graph) {
            var Models;
            (function (Models) {
                let GraphTypes;
                (function (GraphTypes) {
                    GraphTypes[GraphTypes["line"] = 0] = "line";
                    GraphTypes[GraphTypes["area"] = 1] = "area";
                    GraphTypes[GraphTypes["bar"] = 2] = "bar";
                    GraphTypes[GraphTypes["radar"] = 3] = "radar";
                    GraphTypes[GraphTypes["pie"] = 4] = "pie";
                    GraphTypes[GraphTypes["doughnut"] = 5] = "doughnut";
                    GraphTypes[GraphTypes["polarArea"] = 6] = "polarArea";
                    GraphTypes[GraphTypes["bubble"] = 7] = "bubble";
                    GraphTypes[GraphTypes["scatter"] = 8] = "scatter";
                })(GraphTypes = Models.GraphTypes || (Models.GraphTypes = {}));
            })(Models = Graph.Models || (Graph.Models = {}));
        })(Graph = Controls.Graph || (Controls.Graph = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=GraphTypes.pre.js.map
